import { AutoMap } from "@automapper/classes"
import { Portfolio } from "./portfolio"
import { ZoneMeasure } from "../zone-measure"
import { EStrategyType } from "./strategy-type"
import { Work } from "./work"

export class Strategy {

    @AutoMap()
    Id!: number
    @AutoMap()
    Type!: EStrategyType
    @AutoMap()
    ELimsStrategyCode!: string
    @AutoMap()
    ContexteHorsStrategie!: boolean
    @AutoMap()
    Portfolio!: Portfolio
    @AutoMap()
    UpcomingAVT!: string;

    public constructor(init?: Partial<Strategy>) {
        Object.assign(this, init);
    }
}